import axios from "axios";
import {getAuthorizationHeader} from "store/auth/utils";


export const UPDATE_ITEMS = 'UPDATE_ITEMS';
export const DELETE_ITEM = 'DELETE_ITEM';
export const ADD_ITEM = 'ADD_ITEM';
export const ADD_ITEMS = 'ADD_ITEMS';
export const EDIT_ITEM = 'EDIT_ITEM';


export const RETRIEVE_REQUEST = 'RETRIEVE_REQUEST';
export const RETRIEVE_SUCCESS = 'RETRIEVE_SUCCESS';
export const RETRIEVE_ERROR = 'RETRIEVE_ERROR';

export const PUT_REQUEST = 'PUT_REQUEST';
export const PUT_SUCCESS = 'PUT_SUCCESS';
export const PUT_ERROR = 'PUT_ERROR';


export const retrieveRequestFactory = (path, actionName, requiresAuthorization, successAction) => {
    return function () {
        return function (dispatch, getState) {
            const name = actionName.toUpperCase();
            const nameLower = actionName.toLowerCase();
            dispatch({type: `${RETRIEVE_REQUEST}_${name}`});
            const state = getState();
            let input = {
                method: 'get',
                url: process.env.REACT_APP_API_BASE_URL + path + '/?version=' + state[nameLower].version
            };
            if (requiresAuthorization) {
                input.headers = getAuthorizationHeader(state.auth);
            }
            return axios(input).then((response) => {
                if (!successAction) {
                    return dispatch({type: `${RETRIEVE_SUCCESS}_${name}`, payload: response.data})
                }
                return dispatch(successAction(response.data));
            }).catch((error) => {
                console.log(error);
                return dispatch({type: `${RETRIEVE_ERROR}_${name}`});
            });

        }
    }
};

export const putRequestFactory = (path, data, actionName) => {
    return function() {
        return function (dispatch, getState) {
            const name = actionName.toUpperCase();
            const state = getState();
            dispatch({type: `${PUT_REQUEST}_${name}`});
            return axios({
                method: 'put',
                url: process.env.REACT_APP_API_BASE_URL + path + '/',
                headers: getAuthorizationHeader(state.auth),
                data,
            }).then((response) => {
                return dispatch({type: `${PUT_SUCCESS}_${name}`});
            }).catch((error) => {
                console.log(error.response);
                return dispatch({type: `${PUT_ERROR}_${name}`});
            });
        }
    }
};


// WEBPACK FOOTER //
// ./src/store/generic/actions.js